import { SubmissionDefaultStatus } from '@shared/models/submission/status';

export const SUBMISSION_STATUS_LABELS: Record<SubmissionDefaultStatus, string> = {
  [SubmissionDefaultStatus.open]: 'Open',
  [SubmissionDefaultStatus.inProgress]: 'In progress',
  [SubmissionDefaultStatus.closed]: 'Closed',
};
